export type ChatStatus = 'AUTO' | 'WAITING_HUMAN' | 'HUMAN' | 'CLOSED';
export type MessageRole = 'USER' | 'ASSISTANT' | 'ADMIN';

export interface AttachmentDto {
    fileName: string;
    mimeType: string;
    sizeBytes: number;
}

export interface MessageDto {
    role: MessageRole;
    content: string;
    timestamp: string; // ISO instant
    attachment?: AttachmentDto;
}

export interface ChatDto {
    tgId: string;
    username: string;
    status: ChatStatus;
    messages: MessageDto[];
    createdAt: string; // ISO instant
    updatedAt: string; // ISO instant
}

export interface SupportEvent {
    tgId: string;
    message: MessageDto;
}

export const STATUS_LABELS: Record<ChatStatus, string> = {
    AUTO:          'AUTO',
    WAITING_HUMAN: 'ОЖИДАЕТ',
    HUMAN:         'ОПЕРАТОР',
    CLOSED:        'ЗАКРЫТ',
};

export const STATUS_FILTER_OPTIONS: Array<{ value: ChatStatus | 'ALL'; label: string }> = [
    { value: 'ALL',          label: 'ВСЕ' },
    { value: 'WAITING_HUMAN', label: 'ОЖИДАЕТ' },
    { value: 'HUMAN',         label: 'ОПЕРАТОР' },
    { value: 'AUTO',          label: 'AUTO' },
    { value: 'CLOSED',        label: 'ЗАКРЫТ' },
];
